export const integrationOutlet = 'integration';
